import { useAntdTable } from 'ahooks'
import { Col, Form, Input, Row, Select, Table, TableColumnsType, TableProps } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { DepartmentSearch, UserAvatar } from '@/components'
import { currentOKRCycleAtom, okrCyclesAtom } from '@/modules/okr'
import { userInfoAtom } from '@/modules/user'
import { PpObjective, PpObjectiveData } from '@/schemas'

interface OKRListProps extends TableProps<any> {
  renderExtras: any
  extraOperationLoading?: boolean
}

export const OKRList: React.FC<OKRListProps> = ({ renderExtras, extraOperationLoading, ...extraTableProps }) => {
  const { t } = useTranslation()
  const [userInfo] = useAtom(userInfoAtom)
  const [okrCycles] = useAtom(okrCyclesAtom)
  const [currentOKRCycle] = useAtom(currentOKRCycleAtom)
  const [form] = Form.useForm()

  const { tableProps, search } = useAntdTable<PpObjectiveData>(
    (pagination, params) => ({
      url: '/api/okr/getObjectives',
      params: {
        page: pagination.current,
        size: pagination.pageSize,
        ...params,
      },
    }),
    {
      form,
      defaultParams: [
        { current: 1, pageSize: 10 },
        { cycleId: currentOKRCycle!.cycleId, departmentId: userInfo!.departmentIds[0] },
      ],
      defaultPageSize: 10,
      formatResult: (data) => ({ list: data.objectives, total: data.total }),
    }
  )

  const controls = (
    <Form form={form} onValuesChange={search.submit}>
      <Row gutter={[24, 0]}>
        <Col xs={6} lg={5}>
          <Form.Item name='cycleId'>
            <Select options={okrCycles.map((c) => ({ value: c.cycleId, label: c.name }))} />
          </Form.Item>
        </Col>
        <Col xs={6} lg={5}>
          <Form.Item name='departmentId'>
            <DepartmentSearch />
          </Form.Item>
        </Col>
        {/* TODO 支持传 userId */}
        {/* <Col xs={6} lg={5}>
          <Form.Item name='email'>
            <UsersSearch placeholder='搜索负责人' />
          </Form.Item>
        </Col> */}
        <Col xs={6} lg={5}>
          <Form.Item name='name'>
            <Input allowClear placeholder={t('search objectives')} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )

  const columns: TableColumnsType<PpObjective> = [
    {
      title: t('objectives'),
      dataIndex: 'name',
    },
    {
      title: t('owner'),
      render: (_, d) => {
        return <UserAvatar showName email={d.email} />
      },
    },
    {
      align: 'center',
      width: 80,
      render: renderExtras,
    },
  ]

  return (
    <div>
      {controls}
      <Table
        rowKey='objectiveId'
        size='small'
        columns={columns}
        {...tableProps}
        {...extraTableProps}
        loading={extraOperationLoading}
        // @ts-ignore
        pagination={{
          ...tableProps.pagination,
          hideOnSinglePage: true,
        }}
      ></Table>
    </div>
  )
}
